import { useMemo } from 'react';
import {
  PosMultiSelect,
  PosMultiSelectProps,
} from 'src/core/POS/PosMultiSelect';
import { MultiSelectValueChange } from 'src/core/POS/PosMultiSelect/PosMultiSelect.types';
import { useOffices } from 'src/hooks/api/useOffices';

export type OfficeFilterMultiSelectorProps = Omit<
  PosMultiSelectProps,
  'searchable' | 'valueOptionsContent' | 'values' | 'onChange'
> & {
  values: number[];
  onChange: (change: MultiSelectValueChange<number>) => void;
};

export const OfficeFilterMultiSelector = ({
  values,
  onChange,
  ...rest
}: OfficeFilterMultiSelectorProps) => {
  const { query: officesQuery } = useOffices();

  const officeOptions = useMemo(
    () =>
      Object.fromEntries(
        (officesQuery.data ?? []).map((o) => [String(o.officeId), o.officeName])
      ),
    [officesQuery.data]
  );

  return (
    <PosMultiSelect
      {...rest}
      searchable
      loading={officesQuery.isLoading}
      values={values.map(String)}
      onChange={({ newValues, operation }) =>
        onChange({ newValues: newValues.map(Number), operation })
      }
      valueOptionsContent={officeOptions}
    />
  );
};
